import { ENUM_CATEGORY } from '@/components/Lobby/enum.js'

export default {
  live: {
    path: ENUM_CATEGORY.LIVE.URL,
    title: {
      ru: 'Live',
      ua: 'Live',
    },
    img: 'live',
  },
  slots: {
    path: ENUM_CATEGORY.SLOTS.URL,
    title: {
      ru: 'Слоты',
      ua: 'Слоти',
    },
  },
  promotions: {
    path: ENUM_CATEGORY.PROMOTIONS.URL,
    title: {
      ru: 'Акции',
      ua: 'Акції',
    },
  },
  new: {
    path: ENUM_CATEGORY.NEW.URL,
    title: {
      ru: 'Новинки',
      ua: 'Новинки',
    },
  },
  forBonuses: {
    path: ENUM_CATEGORY.FOR_BONUSES.URL,
    title: {
      ru: 'Игра на бонусы',
      ua: 'Гра на бонуси',
    },
  },
  roulette: {
    path: ENUM_CATEGORY.ROULETTE.URL,
    title: {
      ru: 'Рулетка',
      ua: 'Рулетка',
    },
  },
  blackjack: {
    path: ENUM_CATEGORY.BLACKJACK.URL,
    title: {
      ru: 'Блекджек',
      ua: 'Блекджек',
    },
  },
  providers: {
    path: ENUM_CATEGORY.PROVIDERS.URL,
    title: {
      ru: 'Провайдеры',
      ua: 'Провайдери',
    },
  },
  pragmatic: {
    path: ENUM_CATEGORY.PRAGMATIC.URL,
    title: {
      ru: 'Pragmatic',
      ua: 'Pragmatic',
    },
  },
  egt: {
    path: ENUM_CATEGORY.EGT.URL,
    title: {
      ru: 'EGT',
      ua: 'EGT',
    },
  },
  oaks: {
    path: ENUM_CATEGORY.OAKS.URL,
    title: {
      ru: '3 Oaks',
      ua: '3 Oaks',
    },
  },
  playson: {
    path: ENUM_CATEGORY.PLAYSON.URL,
    title: {
      ru: 'Playson',
      ua: 'Playson',
    },
  },
  favourites: {
    path: ENUM_CATEGORY.FAVOURITES.URL,
    title: {
      ru: 'Любимые',
      ua: 'Улюблені',
    },
  },
  lastGames: {
    path: ENUM_CATEGORY.LAST.URL,
    title: {
      ru: 'Просмотренные',
      ua: 'Переглянуті',
    },
  },
}
